module.exports = __webpack_public_path__ + "img/stopcar.bc24ac82.png";